export const AppVersion: string = '1.4.0';
export const BuildVersion: string = '18';
